<template>
  <div class="wrap">
    <div class="banner">
      <div class="text animated fadeIn">
        <p class="icon"></p>
        <p class="h2">联系我们</p>
      </div>
    </div>
    <div class="inner">
      <div class="content">
        <p class="strong">广州埃珥赛璞医疗设备有限公司</p>
        <p>公司地址：广州市黄埔区开源大道188号B栋101房</p>
        <p>邮政编码：510000</p>
        <p>公司总机：020-3885 6297</p>
        <p>传真：020-3885 6297</p>
        <div class="imgbox">
          <div class="map-wrap">
            <el-amap ref="map"
                     vid="amapDemo"
                     :center="center"
                     :zoom="zoom"
                     class="amap-demo">
              <el-amap-marker :position="marker.position"
                              :icon="marker.icon"
                              :label="marker.label"
                              :visible="marker.visible"></el-amap-marker>
            </el-amap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  props: {
    scrollTopNum: Number
  },
  data () {
    return {
      dialogVisible: false,
      selectedProduct: null,
      currentPage: 1,
      itemsPerPage: 10,
      filters: [],
      productList: [
        {
          id: 1,
          identification: 1,
          subidentifier: 11,
          url: require('../../assets/images/airsep/product1.png'),
          title: '（大型 ）医用中心制氧系统'
        },
        {
          id: 2,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product2.jpg'),
          title: '制氧主机'
        },
        {
          id: 3,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product3.jpg'),
          title: '空压机'
        },
        {
          id: 4,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product4.jpg'),
          title: '冷干机'
        },
        {
          id: 5,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product5.jpg'),
          title: '过滤器'
        },
        {
          id: 6,
          identification: 1,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product6.png'),
          title: '纯度分析仪'
        },
        {
          id: 7,
          identification: 2,
          subidentifier: 21,
          url: require('../../assets/images/airsep/product7.png'),
          title: '小型医用中心供氧系统'
        },
        {
          id: 8,
          identification: 2,
          subidentifier: 22,
          url: require('../../assets/images/airsep/product8.png'),
          title: '智能控制器'
        },
        {
          id: 9,
          identification: 2,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product9.jpg'),
          title: '供氧终端3'
        },
        {
          id: 10,
          identification: 2,
          subidentifier: 23,
          url: require('../../assets/images/airsep/product10.png'),
          title: '供氧终端1'
        },
        {
          id: 11,
          identification: 2,
          subidentifier: 23,
          url: require('../../assets/images/airsep/product11.png'),
          title: '供氧终端2'
        },
        {
          id: 12,
          identification: 2,
          subidentifier: 22,
          url: require('../../assets/images/airsep/product12.png'),
          title: '控制器'
        },
        {
          id: 13,
          identification: 3,
          subidentifier: 35,
          url: require('../../assets/images/airsep/product13.png'),
          title: '气体监控系统'
        },
        {
          id: 14,
          identification: 3,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product14.png'),
          title: '二级减压箱'
        },
        {
          id: 15,
          identification: 3,
          subidentifier: 33,
          url: require('../../assets/images/airsep/product15.png'),
          title: '负压管道'
        },
        {
          id: 16,
          identification: 3,
          subidentifier: 33,
          url: require('../../assets/images/airsep/product16.png'),
          title: '负压吸引终端'
        },
        {
          id: 17,
          identification: 3,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product17.png'),
          title: '管道接头'
        },
        {
          id: 18,
          identification: 3,
          subidentifier: 32,
          url: require('../../assets/images/airsep/product18.png'),
          title: '空气压缩机组'
        },
        {
          id: 19,
          identification: 3,
          subidentifier: 34,
          url: require('../../assets/images/airsep/product19.png'),
          title: '其他气体'
        },
        {
          id: 20,
          identification: 3,
          subidentifier: 0,
          url: require('../../assets/images/airsep/product20.png'),
          title: '设备带'
        },
        {
          id: 21,
          identification: 3,
          subidentifier: 32,
          url: require('../../assets/images/airsep/product21.png'),
          title: '压缩空气管道'
        },
        {
          id: 22,
          identification: 3,
          subidentifier: 32,
          url: require('../../assets/images/airsep/product22.png'),
          title: '压缩空气终端'
        },
        {
          id: 23,
          identification: 3,
          subidentifier: 31,
          url: require('../../assets/images/airsep/product23.png'),
          title: '氧气管道'
        },
        {
          id: 24,
          identification: 3,
          subidentifier: 31,
          url: require('../../assets/images/airsep/product24.png'),
          title: '氧气终端'
        },
        {
          id: 25,
          identification: 3,
          subidentifier: 33,
          url: require('../../assets/images/airsep/product25.png'),
          title: '真空机组'
        },
        {
          id: 26,
          identification: 3,
          subidentifier: 31,
          url: require('../../assets/images/airsep/product26.png'),
          title: '（大型）医用中心制氧系统'
        }
      ],
      center: [113.511235, 23.156925], // 固定的中心坐标
      zoom: 30, // 固定的缩放级别
      marker: {
        position: [113.511235, 23.156925], // 固定的标记位置
        visible: true,
        icon: require('../../assets/images/airsep/marker.png'), // 你自己的标记图标路径
        label: {
          content: '广州埃珥赛璞医疗设备有限公司', // 标记标签内容
          offset: [0, -25]
        }
      }
    }
  },
  mounted () {

  },
  computed: {
    cascaderOptions () {
      const options = []
      const idMap = new Map()
      this.productList.forEach(item => {
        if (!idMap.has(item.identification)) {
          idMap.set(item.identification, {
            value: item.identification,
            label: this.getTitleById(item.identification),
            children: []
          })
          options.push(idMap.get(item.identification))
        }
        if (item.subidentifier !== 0) {
          const parent = idMap.get(item.identification)
          if (!parent.children.some(child => child.value === item.subidentifier)) {
            parent.children.push({
              value: item.subidentifier,
              label: this.getTitleById(item.subidentifier)
            })
          }
        }
      })
      return options
    },
    filteredList () {
      return this.productList.filter(item => {
        if (this.filters.length === 0) return true
        if (this.filters.length === 1) return item.identification === this.filters[0]
        if (this.filters.length === 2) return item.identification === this.filters[0] && item.subidentifier === this.filters[1]
        return false
      })
    },
    paginatedList () {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.filteredList.slice(start, end)
    }
  },
  watch: {},
  methods: {
    handlePageChange (page) {
      this.currentPage = page
    },
    handleFilterChange () {
      this.currentPage = 1
    },
    getTitleById (id) {
      // 根据id返回对应的title，这里你需要自己实现这个函数逻辑
      const titles = {
        1: '医用中心制氧系统',
        2: '小型医用中心制氧系统',
        3: '医用气体系统',
        11: '（大型 ）医用中心制氧系统',
        21: '（小型）医用中心制氧系统',
        22: '控制器',
        23: '供氧终端',
        31: '氧气系统',
        32: '压缩空气系统',
        33: '负压呼吸系统',
        34: '其他气体',
        35: '气体监控系统'
      }
      return titles[id] || '未知分类'
    },
    showDeviceDetail (product) {
      this.selectedProduct = product
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 444px;
  margin-top: 76px;
  background: url("../../assets/images/banner2.png") no-repeat center;
  text-align: center;
  overflow: hidden;
  .text {
    display: inline-block;
    margin: 117px auto 0;
  }
  .icon {
    width: 105px;
    height: 105px;
    margin: 0 auto;
    background: url("../../assets/images/banner2-icon.png") no-repeat center;
  }
  .h2 {
    font-size: 30px;
    color: #fff;
    margin-top: 62px;
  }
}
.inner {
  width: 1200px;
  min-height: 600px;
  margin: 20px auto;
  background-color: #f2f2f2;
  padding: 10px;
  .content{
    min-height: 600px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 10px;
    p{
      font-size: 18px;
      line-height: 36px;
    }
    .strong{
      color: #434343;
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 18px;
    }
    .imgbox{
      width: 100%;
      height: 450px;
      margin-top: 10px;
      .map-wrap {
        width: 100%;
        height: 100%;
      }

      .amap-demo {
        height: 100%;
        position: relative;
      }
    }
  }
}
</style>
